var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 9,
    viewBox: "0 0 20 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C1.85861 2.04142 2.87009 2.9467 4 3.685M4 3.685C5.21621 4.47928 6.57444 5.03106 8 5.31C9.32123 5.5641 10.6788 5.5641 12 5.31C13.4256 5.03106 14.7838 4.47928 16 3.685M4 3.685L2.5 5.5M19 1C18.1414 2.04142 17.1299 2.9467 16 3.685M16 3.685L17.5 5.5M8 5.309L7.5 7.5M12 5.309L12.5 7.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.2f0bbba2919fe35882b5949a4e83fba6.svg";
export { ForwardRef as ReactComponent };